import { render, staticRenderFns } from "./TotalsMonth.vue?vue&type=template&id=2fcc7101&scoped=true&"
import script from "./TotalsMonth.vue?vue&type=script&lang=js&"
export * from "./TotalsMonth.vue?vue&type=script&lang=js&"
import style0 from "./TotalsMonth.vue?vue&type=style&index=0&id=2fcc7101&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc7101",
  null
  
)

export default component.exports